$(document).ready(function () {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 50) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
  });
});